import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import { FormGroup, Label, Input } from 'reactstrap';

function AgencyDetail() {
  const dispatch = useDispatch();
  const {
    details: {
      values: details,
      editing,
      saving,
    },
    agencies: { records: agencies },
  } = useSelector(store => store);

  function handleChange(e) {
    const { value } = e.target;
    dispatch({
      type: 'EDIT_DETAILS',
      id: 'agency',
      value: value !== null ? Number(value) : '',
      valid: true,
    });
  }

  // NOTE(santeyio): there's something weird that happens with this logic...
  // store.details.values.agency and store.details.values.agency_id are both
  // used to represent agency. When sending to the api it needs to be sent as
  // 'agency' and when it is returned from the api it is returned as 'agency_id'.
  const agencyID = (details.agency || details.agency_id);

  return (
    <div className="font-large mb-2">
      <label htmlFor="agency" className="form-label fw-bold">
        Agent Group
      </label>
      <select
        className="form-select"
        name="agency"
        id="agency"
        onChange={(e) => handleChange(e)}
        value={agencyID || ''}
        disabled={!editing || saving}
      >
        <option value="" disabled>UNASSIGNED</option>
        {agencies.map((agency) => (
          <option key={agency.id} value={agency.id}>{agency.name}</option>
        ))}
      </select>
    </div>
  );
}

export default AgencyDetail;
